import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homefour-about',
  templateUrl: './homefour-about.component.html',
  styleUrls: ['./homefour-about.component.scss']
})
export class HomefourAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
